const ok = { valid: true, message: '' };
const isEmpty = (v) => v === undefined || v === null || String(v).trim() === '';
export const validateBizNo = (value) => {
  if (isEmpty(value)) return ok;
  const digits = String(value).replace(/-/g, '');
  return /^\d{10}$/.test(digits) ? ok : { valid: false, message: '사업자번호 형식이 올바르지 않습니다 (숫자 10자리)' };
};
export const validateEmail = (value) => {
  if (isEmpty(value)) return ok;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim()) ? ok : { valid: false, message: '이메일 형식이 올바르지 않습니다' };
};
export const validatePhone = (value) => {
  if (isEmpty(value)) return ok;
  const digits = String(value).replace(/-/g, '');
  return /^\d{9,11}$/.test(digits) ? ok : { valid: false, message: '연락처 형식이 올바르지 않습니다 (숫자 9~11자리)' };
};
export const VALIDATORS = { bizNo: validateBizNo, email: validateEmail, phone: validatePhone };
